import { SVGProps } from 'react';

const Codepen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 15.5v-7L12 2 2 8.5v7L12 22zM12 2v6.5m10 0-10 7m10 0-10-7M12 22v-6.5m-10 0 10-7m-10 0 10 7"
    />
  </svg>
);
export default Codepen;
